import { render, staticRenderFns } from "./pt-PT.vue?vue&type=template&id=5d2873dc&"
import script from "./pt-PT.vue?vue&type=script&lang=js&"
export * from "./pt-PT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2873dc')) {
      api.createRecord('5d2873dc', component.options)
    } else {
      api.reload('5d2873dc', component.options)
    }
    module.hot.accept("./pt-PT.vue?vue&type=template&id=5d2873dc&", function () {
      api.rerender('5d2873dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/pt-PT.vue"
export default component.exports